export const COUNTRIES: string[] = [
  'Nederland',
  'België',
  'Duitsland',
  'Nederlandse Antillen',
  'Afghanistan',
  'Albanië',
  'Algerije',
  'Amerikaanse Overzeese eilanden',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antartica',
  'Antigua',
  'Argentinië',
  'Armenië',
  'Aruba',
  'Australië',
  'Azerbeidzjan',
  'Bahama\'s',
  'Bahrein',
  'Bangladesh',
  'Barbados',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnië-Herzegovina',
  'Botswana',
  'Bouvet',
  'Brazilië',
  'Brits Indiaanse Oceaangebied',
  'Brunei',
  'Bulgarije',
  'Burkina Faso',
  'Burundi',
  'Cambodja',
  'Canada',
  'Centraal-Afrikaanse Republiek',
  'Chili',
  'China',
  'Colombia',
  'Comoren',
  'Congo',
  'Congo',
  'Cookeiland',
  'Costa Rica',
  'Cuba',
  'Cyprus',
  'Denemarken',
  'Djibouti',
  'Dominica',
  'Dominicaanse Republiek',
  'Ecuador',
  'Egypte',
  'El Salvador',
  'Equatoriaal Guinee',
  'Eritrea',
  'Estland',
  'Ethiopië',
  'Faeröer',
  'Falklandeilanden',
  'Fiji',
  'Filipijnen',
  'Finland',
  'Frankrijk',
  'Frans-Guyana',
  'Frans-Polynesië',
  'Franse zuidelijke territoria',
  'Gabon',
  'Gambia',
  'Georgië',
  'Ghana',
  'Gibraltar',
  'Grenada',
  'Griekenland',
  'Groenland',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guiee-Bissau',
  'Guinee',
  'Guyana',
  'Haïti',
  'Heard en McDonald eiland',
  'Honduras',
  'Hongarije',
  'Hongkong',
  'Ierland',
  'Ijsland',
  'India',
  'Indonesië',
  'Irak',
  'Iran',
  'Israël',
  'Italië',
  'Ivoorkust',
  'Jamaica',
  'Japan',
  'Jemen',
  'Joegoslavië',
  'Jordanië',
  'Kaaimaneilanden',
  'Kaapverdië',
  'Kameroen',
  'Kazachstan',
  'Kenia',
  'Kersteiland',
  'Kirgizië',
  'Kiribati',
  'Koeweit',
  'Kokoseiland',
  'Kroatië',
  'Laos',
  'Lesotho',
  'Letland',
  'Libanon',
  'Liberia',
  'Libië',
  'Liechtenstein',
  'Litouwen',
  'Luxemburg',
  'Maagdeneilanden (UK)',
  'Maagdeneilanden (VS)',
  'Macau',
  'Macedonië',
  'Madagaskar',
  'Malawi',
  'Malediven',
  'Maleisië',
  'Mali',
  'Malta',
  'Marokko',
  'Marshalleilanden',
  'Martinique',
  'Mauretanië',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesië',
  'Moldavië',
  'Monaco',
  'Mongolië',
  'Monsterrat',
  'Mozambique',
  'Myanmar',
  'Namibië',
  'Nauru',
  'Nepal',
  'Nicaragua',
  'Nieuw-Caledonië',
  'Nieuw-Zeeland',
  'Niger',
  'Nigeria',
  'Niue',
  'Noord-Korea',
  'Noordelijke Mariana-eilanden',
  'Noorwegen',
  'Norkfolkeiland',
  'Oekraïne',
  'Oezbekistan',
  'Oman',
  'Oost-Timor',
  'Oostenrijk',
  'Pakistan',
  'Palau',
  'Panama',
  'Papoea Nieuw-Guinea',
  'Paraguay',
  'Peru',
  'Pitcairneiland',
  'Polen',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Roemenië',
  'Rusland',
  'Rwanda',
  'Samoa',
  'Samoa',
  'San Marino',
  'Sao Tomé en Principe',
  'Saudi-Arabië',
  'Senegal',
  'Seychellen',
  'Sierra Leone',
  'Singapore',
  'Slovenië',
  'Slowakije',
  'Solomoneilanden',
  'Somalië',
  'Spanje',
  'Sri Lanka',
  'St. Helena',
  'St. Kitts',
  'St. Lucia',
  'St. Pierre',
  'St. Vincent',
  'Sudan',
  'Suriname',
  'Svalbard en Jan Mayen',
  'Swaziland',
  'Syrië',
  'Tadzjikistan',
  'Taiwan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad en Tobago',
  'Tsjaad',
  'Tsjechië',
  'Tunesië',
  'Turkije',
  'Turkmenistan',
  'Turks- en Caico-eiland',
  'Tuvalu',
  'Uganda',
  'Uruguay',
  'Vanuatu',
  'Vaticaanstad',
  'Venezuela',
  'Verenigd Koninkrijk',
  'Verenigde Arabische Emiraten',
  'Verenigde Staten',
  'Vietnam',
  'Wallis en Futuna',
  'West-Sahara',
  'Wit-Rusland',
  'Zambia',
  'Zimbabwe',
  'Zuid-Afrika',
  'Zuid-Georgië',
  'Zuid-Korea',
  'Zweden',
  'Zwitserland',
];
